<ng-container *transloco="let t">
  <div class="heading-container p-3 align-items-start align-items-xxl-center {{cssClass ? cssClass : ''}}"
       [ngClass]="{'clickable': type === LiveResultHeadingType.EVENT}" (click)="onHeadingClick()">
    <div class=" d-none d-xxl-flex">
      <ng-container *ngTemplateOutlet="imageHolderTemplate;
      context: {
        status: status,
        race: race,
        event: event
      }"></ng-container>
    </div>
    <div class="ps-3 info">
      <ng-content select="[slot='title-slot']"></ng-content>
      <div class="d-flex d-xxl-none">
        <ng-container *ngTemplateOutlet="badgeTemplate; context: { status: status }"></ng-container>
      </div>
      @if (type === LiveResultHeadingType.RACE && event) {
        <p class="info__small">
          <app-language-output [hrLabel]="event.name" [srLabel]="event.nameSr" [enLabel]="event.nameEng"
                               [itLabel]="event.nameIta" [bsLabel]="event.nameBs" [siLabel]="event.nameSlo"
                               [bsLabel]="event.nameBs" [defaultLanguage]="event.defaultLanguage"
                               [languages]="languages"/>
        </p>
      }

      <p class="large text-uppercase pb-3 pb-xxl-0">
        @if (type === LiveResultHeadingType.RACE && race) {
          <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng" [srLabel]="race.nameSr"
                               [itLabel]="race.nameIta" [siLabel]="race.nameSlo" [bsLabel]="race.nameBs"
                               [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>


        } @else if (type === LiveResultHeadingType.EVENT && event) {
          <app-language-output [hrLabel]="event.name" [srLabel]="event.nameSr" [enLabel]="event.nameEng"
                               [itLabel]="event.nameIta" [bsLabel]="event.nameBs" [siLabel]="event.nameSlo"
                               [defaultLanguage]="event.defaultLanguage" [languages]="languages"/>

        }
      </p>

      <div class="info__details d-flex flex-column flex-xxl-row align-items-start">

        <!-- Reusable ng-template za sport badge i sport tekst -->
        <ng-template #sportBadgeTemplate let-type="type" let-race="race" let-event="event" let-cssClass="cssClass">
          <ng-container *ngIf="type === LiveResultHeadingType.RACE && race?.sport; else eventSport">
            <p class="text-uppercase{{cssClass ? ' ' + cssClass : ''}}">
              {{t("app.common.sports." + race!.sport)}} </p>
          </ng-container>

          <ng-template #eventSport>
            <ng-container *ngIf="type === LiveResultHeadingType.EVENT && event?.sportOne">
              <p class="text-uppercase{{cssClass ? ' ' + cssClass : ''}}">
                {{t("app.common.sports." + event!.sportOne)}} </p>
            </ng-container>
          </ng-template>
        </ng-template>

        <!-- Prikaz za male ekrane (d-xxl-none) -->
        <div class="d-flex d-xxl-none pb-2">
          <div class="badge-holder">
            <div class="badge-holder__badge sport-badge info__details--block">
              <ng-container *ngTemplateOutlet="sportBadgeTemplate; context: {
                type: type,
                race: race,
                event: event,
                cssClass: cssClass
              }"></ng-container>
            </div>
          </div>
        </div>

        <!-- Prikaz za velike ekrane (d-xxl-flex) -->
        <div class="d-none d-xxl-flex info__details--block">
          <ng-container *ngTemplateOutlet="sportBadgeTemplate; context: {
            type: type,
            race: race,
            event: event,
            cssClass: cssClass
          }"></ng-container>
        </div>

        <div class="d-flex align-items-center info__details--block pb-1 pb-xxl-0">
          <div class="d-flex pe-1">
            <img src="assets/icons/icons-alt/calendar-04.svg" alt="Start time"/>
          </div>
          <p class="regular {{cssClass ? cssClass : ''}}">{{dateString}}</p>

          @if (type === LiveResultHeadingType.RACE) {
            <p class="regular ms-2 {{cssClass ? cssClass : ''}}">{{
                race?.raceStart | localizedDate:"HH:mm"
              }} </p>
          }
        </div>

        @if (type === LiveResultHeadingType.EVENT && (event?.city || country)) {
          <div class="d-flex align-items-center">
            <div class="d-flex pe-1">
              <img src="assets/icons/icons-alt/location-alt.svg" alt="Start time"/>
            </div>
            <p class="regular {{cssClass ? cssClass : ''}}">
              {{event?.city ?? ""}}{{event?.city && country ? ", " : ""}}{{country ?? ""}} </p>
          </div>
        }

        @if (type === LiveResultHeadingType.RACE) {
          <div class="d-flex align-items-center info__details--block pb-1 pb-xxl-0">
            <p class="regular {{cssClass ? cssClass : ''}}">
              {{t("event.item.participants")}}:
              <span class="fw-medium ps-1">{{started ?? "-"}}</span>
            </p>
          </div>
          @if (finished && finished > 0) {
            <div class="d-flex align-items-center info__details--block pb-1 pb-xxl-0">
              <p class="regular {{cssClass ? cssClass : ''}}">
                {{t("app.common.finished")}}:
                <span class="fw-medium ps-1">{{finished}}</span>
              </p>
            </div>
          }
        }
      </div>
    </div>
    <ng-content></ng-content>
    <div class=" d-flex d-xxl-none">
      <ng-container *ngTemplateOutlet="imageHolderTemplate;
      context: {
        status: status,
        race: race,
        event: event
      }"></ng-container>
    </div>
    <div class=" d-none d-xxl-flex">
      <ng-container *ngTemplateOutlet="badgeTemplate; context: { status: status }"></ng-container>
    </div>
  </div>

  <ng-template #imageHolderTemplate let-status="status" let-race="race" let-event="event">
    <div class="image_holder">
      <div class="circle-container">

        <ng-container *ngIf="status === LiveItemStatus.IN_PROGRESS">
          <div class="loader">
            <div class="outer-circle"></div>
            <div class="loader-edge"></div>
            <div class="inner-circle"></div>
          </div>
        </ng-container>

        <div class="image-circle">
          <ng-container *ngIf="race?.imageIcon !== null; else eventImage">
            <img [src]="race!.imageIcon!" alt="">
          </ng-container>

          <ng-template #eventImage>
            <ng-container *ngIf="event?.imageIcon !== null; else defaultImage">
              <img [src]="event!.imageIcon!" alt="">
            </ng-container>
          </ng-template>

          <ng-template #defaultImage>
            <img src="assets/img/bg3.jpg" alt="">
          </ng-template>
        </div>

      </div>
    </div>
  </ng-template>

  <ng-template #badgeTemplate let-status="status">
    @if (!hideStatusBadge) {
      <div class="badge-holder">
        <div class="badge-holder__badge" [ngClass]="{
        'finished': status === LiveItemStatus.FINISHED,
        'in-progress': status === LiveItemStatus.IN_PROGRESS,
        'to-be-started': status === LiveItemStatus.TO_BE_STARTED}">
      <span class="text-uppercase">
        {{t("live.results.status." + status)}}
      </span>
        </div>
      </div>
    }
  </ng-template>

</ng-container>

